module.exports = __webpack_public_path__ + "static/media/bullrig.26c1c7bc.mp3";